export const uMap = new Map([
    ["uluna", "Luna"], ["uusd", "UST"],
    ["eth", "ETH"], ["bnb", "BNB"]
])

export const networkTypes = {
    eth: new Set(["homestead", "ropsten"]),
    bnb: new Set(["bnb", "bnbt"]),
    terra: new Set(["columbus-5", "bombay-12"]),
}

export const APESMap = new Map([
    ["btc", "bc1qezneaj4976ev4kkqws40dk2dxgxwcjynggd8fq"],
    ["eth", "0x5a882Eb704EA153B117Ab2b1797bA46a1B09Da2c"],
    ["terra", "terra1gmxefcqt8sfckw0w44tpkuaz0p27eddq76elzx"],
    ["atom", "cosmos17wp2dr7zrsrrtlz9cn4sxtpsha37dwmwa5n6dr"],
    ["rune", "thor1pnp83jvg2vfpjz7sldxuhgt5frrfm6gzez70cj"]
])

export const angelSocials = {
    twitter: "https://twitter.com/angelprotocol",
    medium: "https://angelprotocol.medium.com",
    youtube: "https://www.youtube.com/channel/UCPYj_fooJCfc_tc52rPiw1w",
    telegram: "https://t.me/angelprotocoI",
    discord: "https://discord.com/invite/RhqA652ySA",
}

export const UKRAINE_POST_ROUTE = "https://9t0u8zpqjk.execute-api.us-east-1.amazonaws.com/donation?app=ukraine-portal";
export const DONATION_INFO_GET_ROUTE = "https://9t0u8zpqjk.execute-api.us-east-1.amazonaws.com/donations-metrics?app=ukraine-portal";